var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.444 0h23.111v7.111H4.444V0zM4.444 23.111h23.111V32H4.444v-8.889zM29.724 8.036H2.275a2.28 2.28 0 0 0-2.276 2.276v9.653a2.28 2.28 0 0 0 2.276 2.276h27.431a2.28 2.28 0 0 0 2.276-2.276v-9.653a2.254 2.254 0 0 0-2.258-2.276zM28 20.267c-.978 0-1.778-.8-1.778-1.778s.8-1.778 1.778-1.778 1.778.8 1.778 1.778-.8 1.778-1.778 1.778z"
  })));
};
export default SvgPrint;